module.exports = __webpack_public_path__ + "img/icon-reg-create-event.e9b50293.png";